exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".tree-breadcrumb[data-v-1b2a1be4]{overflow:auto;font-size:14px;line-height:18px;padding:16px 0;background:#fff;box-shadow:inset 0 -1px 0 0 #edf2fb}.tree-breadcrumb-track[data-v-1b2a1be4]{white-space:nowrap;display:inline-flex}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-rewriter.js?id=data-v-1b2a1be4&scoped=true!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/source/breadcrumb.vue
// module id = 310
// module chunks = 0